// // // // src/components/TemplateMini.jsx
// // // // Renders a full-fidelity resume preview scaled down via CSS transform.
// // // // This guarantees the preview EXACTLY matches the generated resume.
// // // //
// // // // How it works:
// // // //   - Renders a full-size (600px wide) resume layout
// // // //   - CSS transform: scale(0.28) shrinks it to ~168px wide
// // // //   - The outer wrapper clips to the correct display size
// // // //
// // // // To add a new template:
// // // //   1. Add a case in renderResume() below
// // // //   2. Set active:true in servicesConfig.resumeTemplates

// // // import React from "react";

// // // // ── Sample data shown in every preview ──
// // // const SAMPLE = {
// // //   name:     "Jonathan Carter",
// // //   title:    "Senior Product Manager",
// // //   email:    "john@email.com",
// // //   phone:    "(555) 123-4567",
// // //   location: "New York, NY",
// // //   linkedin: "linkedin.com/in/jcarter",
// // //   summary:  "Results-driven Product Manager with 8+ years delivering high-impact products at Fortune 500 companies. Proven track record of increasing retention and driving revenue growth.",
// // //   experience: [
// // //     {
// // //       title: "Senior Product Manager",
// // //       company: "Google",
// // //       location: "New York, NY",
// // //       dates: "Jan 2020 – Present",
// // //       bullets: [
// // //         "Led cross-functional team of 12 to deliver 3 major features ahead of schedule",
// // //         "Increased DAU by 34% through data-driven roadmap prioritization",
// // //         "Managed $2M annual product budget across 4 verticals",
// // //       ],
// // //     },
// // //     {
// // //       title: "Product Manager",
// // //       company: "Stripe",
// // //       location: "San Francisco, CA",
// // //       dates: "Mar 2017 – Dec 2019",
// // //       bullets: [
// // //         "Launched payments API now used by 5,000+ merchants globally",
// // //         "Reduced customer churn by 18% via UX research and A/B testing",
// // //       ],
// // //     },
// // //   ],
// // //   education: { degree: "B.S. Computer Science", school: "MIT", year: "2015", gpa: "3.8" },
// // //   skills: ["React", "Node.js", "Python", "SQL", "Agile", "Figma", "Data Analysis"],
// // // };

// // // // ── Shared section title styles ──
// // // function SecTitle({ children, accent, style = "underline" }) {
// // //   if (style === "filled") return (
// // //     <div style={{ background: `${accent}18`, borderLeft: `3px solid ${accent}`, padding: "3px 8px", marginBottom: 8, borderRadius: "0 4px 4px 0" }}>
// // //       <div style={{ fontSize: 9, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.1em", color: accent }}>{children}</div>
// // //     </div>
// // //   );
// // //   if (style === "mono") return (
// // //     <div style={{ background: `${accent}18`, borderLeft: `3px solid ${accent}`, padding: "3px 8px", marginBottom: 8, borderRadius: "0 4px 4px 0" }}>
// // //       <div style={{ fontSize: 9, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.1em", color: accent, fontFamily: "'Courier New',monospace" }}>{`// ${children.toUpperCase()}`}</div>
// // //     </div>
// // //   );
// // //   return (
// // //     <div style={{ borderBottom: `1.5px solid ${accent}`, paddingBottom: 3, marginBottom: 8 }}>
// // //       <div style={{ fontSize: 9, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.1em", color: accent }}>{children}</div>
// // //     </div>
// // //   );
// // // }

// // // // ── Shared body content (summary + experience + education + skills) ──
// // // function ResumeBody({ accent, sectionStyle = "underline", fontFamily = "Arial,Helvetica,sans-serif" }) {
// // //   return (
// // //     <div style={{ fontFamily }}>
// // //       {/* Summary */}
// // //       <div style={{ marginBottom: 12 }}>
// // //         <SecTitle accent={accent} style={sectionStyle}>Professional Summary</SecTitle>
// // //         <p style={{ fontSize: 10, lineHeight: 1.6, color: "#374151", margin: 0 }}>{SAMPLE.summary}</p>
// // //       </div>
// // //       {/* Experience */}
// // //       <div style={{ marginBottom: 12 }}>
// // //         <SecTitle accent={accent} style={sectionStyle}>Work Experience</SecTitle>
// // //         {SAMPLE.experience.map((exp, i) => (
// // //           <div key={i} style={{ marginBottom: 10 }}>
// // //             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 2 }}>
// // //               <div>
// // //                 <span style={{ fontWeight: 700, fontSize: 11, color: "#0f172a" }}>{exp.title}</span>
// // //                 <span style={{ color: "#475569", fontSize: 10 }}> — {exp.company}</span>
// // //               </div>
// // //               <span style={{ fontSize: 9, color: "#64748b", fontStyle: "italic", whiteSpace: "nowrap" }}>{exp.dates}</span>
// // //             </div>
// // //             <ul style={{ margin: "3px 0 0 14px", padding: 0 }}>
// // //               {exp.bullets.map((b, j) => (
// // //                 <li key={j} style={{ fontSize: 9.5, color: "#374151", marginBottom: 2, lineHeight: 1.5 }}>{b}</li>
// // //               ))}
// // //             </ul>
// // //           </div>
// // //         ))}
// // //       </div>
// // //       {/* Education */}
// // //       <div style={{ marginBottom: 12 }}>
// // //         <SecTitle accent={accent} style={sectionStyle}>Education</SecTitle>
// // //         <div style={{ display: "flex", justifyContent: "space-between" }}>
// // //           <div>
// // //             <span style={{ fontWeight: 700, fontSize: 11, color: "#0f172a" }}>{SAMPLE.education.degree}</span>
// // //             <span style={{ color: "#475569", fontSize: 10 }}> — {SAMPLE.education.school}</span>
// // //           </div>
// // //           <span style={{ fontSize: 9, color: "#64748b", fontStyle: "italic" }}>{SAMPLE.education.year}</span>
// // //         </div>
// // //       </div>
// // //       {/* Skills */}
// // //       <div>
// // //         <SecTitle accent={accent} style={sectionStyle}>Skills</SecTitle>
// // //         <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
// // //           {SAMPLE.skills.map(s => (
// // //             <span key={s} style={{ fontSize: 9, background: `${accent}14`, color: accent, padding: "2px 7px", borderRadius: 3, border: `0.5px solid ${accent}30`, fontWeight: 600 }}>{s}</span>
// // //           ))}
// // //         </div>
// // //       </div>
// // //     </div>
// // //   );
// // // }

// // // // ── Per-template full-size renderers ──
// // // function renderResume(id, accent, headerBg) {
// // //   const a = accent;    // shorthand used throughout
// // //   const h = headerBg; // shorthand used throughout
// // //   const contacts = [SAMPLE.email, SAMPLE.phone, SAMPLE.location, SAMPLE.linkedin];

// // //   if (id === "classic") return (
// // //     <div style={{ fontFamily: "Georgia,'Times New Roman',serif", background: "#fff" }}>
// // //       <div style={{ textAlign: "center", paddingBottom: 14, marginBottom: 14, borderBottom: `2px solid ${accent}` }}>
// // //         <h1 style={{ fontSize: 22, fontWeight: 700, color: "#0f172a", marginBottom: 4, letterSpacing: "-0.01em" }}>{SAMPLE.name}</h1>
// // //         <div style={{ fontSize: 10, color: "#555", marginBottom: 6 }}>{SAMPLE.title}</div>
// // //         <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: 12, fontSize: 9.5, color: "#475569" }}>
// // //           {contacts.map(c => <span key={c}>{c}</span>)}
// // //         </div>
// // //       </div>
// // //       <ResumeBody accent={accent} sectionStyle="underline" fontFamily="Arial,Helvetica,sans-serif" />
// // //     </div>
// // //   );

// // //   if (id === "modern") return (
// // //     <div style={{ display: "flex", background: "#fff", fontFamily: "Arial,Helvetica,sans-serif" }}>
// // //       <div style={{ width: 170, background: headerBg, padding: "20px 14px", flexShrink: 0 }}>
// // //         <div style={{ width: 52, height: 52, borderRadius: "50%", background: "rgba(255,255,255,0.18)", marginBottom: 12 }} />
// // //         <div style={{ fontSize: 13, fontWeight: 800, color: "#fff", marginBottom: 2 }}>{SAMPLE.name}</div>
// // //         <div style={{ fontSize: 9.5, color: `${accent}dd`, background: "rgba(255,255,255,0.1)", padding: "2px 6px", borderRadius: 3, display: "inline-block", marginBottom: 12 }}>{SAMPLE.title}</div>
// // //         <div style={{ height: 1, background: "rgba(255,255,255,0.15)", marginBottom: 12 }} />
// // //         <div style={{ fontSize: 8, fontWeight: 700, color: "rgba(255,255,255,0.5)", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 6 }}>Contact</div>
// // //         {contacts.map(c => <div key={c} style={{ fontSize: 8.5, color: "rgba(255,255,255,0.75)", marginBottom: 4, wordBreak: "break-all" }}>{c}</div>)}
// // //         <div style={{ height: 1, background: "rgba(255,255,255,0.15)", margin: "12px 0" }} />
// // //         <div style={{ fontSize: 8, fontWeight: 700, color: "rgba(255,255,255,0.5)", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 6 }}>Skills</div>
// // //         {SAMPLE.skills.slice(0, 5).map((s, i) => (
// // //           <div key={s} style={{ marginBottom: 5 }}>
// // //             <div style={{ fontSize: 8.5, color: "rgba(255,255,255,0.8)", marginBottom: 2 }}>{s}</div>
// // //             <div style={{ height: 3, background: "rgba(255,255,255,0.15)", borderRadius: 2 }}>
// // //               <div style={{ height: "100%", width: `${85 - i * 8}%`, background: "rgba(255,255,255,0.65)", borderRadius: 2 }} />
// // //             </div>
// // //           </div>
// // //         ))}
// // //       </div>
// // //       <div style={{ flex: 1, padding: "20px 18px" }}>
// // //         <ResumeBody accent={accent} sectionStyle="filled" fontFamily="Arial,Helvetica,sans-serif" />
// // //       </div>
// // //     </div>
// // //   );

// // //   if (id === "executive") return (
// // //     <div style={{ fontFamily: "Arial,Helvetica,sans-serif", background: "#fff" }}>
// // //       <div style={{ background: headerBg, padding: "20px 24px 16px" }}>
// // //         <h1 style={{ fontSize: 22, fontWeight: 700, color: "#fff", textTransform: "uppercase", letterSpacing: "0.06em", fontFamily: "Georgia,serif", marginBottom: 6 }}>{SAMPLE.name}</h1>
// // //         <div style={{ height: 1.5, background: "rgba(255,255,255,0.3)", marginBottom: 2 }} />
// // //         <div style={{ height: 0.5, background: "rgba(255,255,255,0.12)", marginBottom: 10 }} />
// // //         <div style={{ display: "flex", flexWrap: "wrap", gap: 16, fontSize: 9.5, color: "rgba(255,255,255,0.6)" }}>
// // //           {contacts.map(c => <span key={c}>{c}</span>)}
// // //         </div>
// // //       </div>
// // //       <div style={{ padding: "16px 24px" }}>
// // //         <ResumeBody accent={accent} sectionStyle="underline" fontFamily="Arial,Helvetica,sans-serif" />
// // //       </div>
// // //     </div>
// // //   );

// // //   if (id === "minimal") return (
// // //     <div style={{ fontFamily: "'Helvetica Neue',Helvetica,Arial,sans-serif", background: "#fff" }}>
// // //       <div style={{ paddingBottom: 14, marginBottom: 14, borderBottom: `2.5px solid ${accent}` }}>
// // //         <h1 style={{ fontSize: 24, fontWeight: 300, color: "#0f172a", letterSpacing: "-0.02em", marginBottom: 4 }}>{SAMPLE.name}</h1>
// // //         <div style={{ width: 28, height: 2.5, background: accent, borderRadius: 2, marginBottom: 8 }} />
// // //         <div style={{ fontSize: 10, color: "#555", marginBottom: 6 }}>{SAMPLE.title}</div>
// // //         <div style={{ display: "flex", flexWrap: "wrap", gap: 12, fontSize: 9.5, color: "#64748b" }}>
// // //           {contacts.slice(0, 3).map(c => <span key={c}>{c}</span>)}
// // //         </div>
// // //       </div>
// // //       <ResumeBody accent={accent} sectionStyle="underline" fontFamily="'Helvetica Neue',Helvetica,Arial,sans-serif" />
// // //     </div>
// // //   );

// // //   if (id === "corporate") return (
// // //     <div style={{ fontFamily: "Arial,Helvetica,sans-serif", background: "#fff" }}>
// // //       <div style={{ background: `linear-gradient(135deg,${headerBg},${accent})`, padding: "20px 24px 16px" }}>
// // //         <h1 style={{ fontSize: 20, fontWeight: 700, color: "#fff", fontFamily: "Georgia,serif", marginBottom: 3 }}>{SAMPLE.name}</h1>
// // //         <div style={{ fontSize: 10, color: "rgba(200,225,255,0.8)", fontStyle: "italic", marginBottom: 10 }}>{SAMPLE.title}</div>
// // //         <div style={{ height: 1, background: "rgba(255,255,255,0.2)", marginBottom: 8 }} />
// // //         <div style={{ display: "flex", flexWrap: "wrap", gap: 14, fontSize: 9, color: "rgba(200,225,255,0.85)" }}>
// // //           {contacts.map(c => <span key={c}>{c}</span>)}
// // //         </div>
// // //       </div>
// // //       <div style={{ padding: "16px 24px" }}>
// // //         <ResumeBody accent={accent} sectionStyle="filled" fontFamily="Arial,Helvetica,sans-serif" />
// // //       </div>
// // //     </div>
// // //   );

// // //   if (id === "creative") return (
// // //     <div style={{ fontFamily: "Arial,Helvetica,sans-serif", background: "#fff" }}>
// // //       <div style={{ background: `linear-gradient(135deg,${headerBg},${accent})`, padding: "22px 24px 38px", clipPath: "polygon(0 0,100% 0,100% 80%,0 100%)", marginBottom: -6 }}>
// // //         <h1 style={{ fontSize: 24, fontWeight: 800, color: "#fff", fontFamily: "Georgia,serif", letterSpacing: "-0.02em", marginBottom: 4 }}>{SAMPLE.name}</h1>
// // //         <div style={{ fontSize: 9.5, color: "rgba(255,210,220,0.9)", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 8 }}>{SAMPLE.title}</div>
// // //         <div style={{ display: "flex", flexWrap: "wrap", gap: 12, fontSize: 9, color: "rgba(255,210,220,0.8)" }}>
// // //           {contacts.slice(0, 3).map(c => <span key={c}>{c}</span>)}
// // //         </div>
// // //       </div>
// // //       <div style={{ padding: "10px 24px 16px" }}>
// // //         <ResumeBody accent={accent} sectionStyle="underline" fontFamily="Arial,Helvetica,sans-serif" />
// // //       </div>
// // //     </div>
// // //   );

// // //   if (id === "technical") return (
// // //     <div style={{ fontFamily: "Arial,Helvetica,sans-serif", background: "#fff" }}>
// // //       <div style={{ background: `linear-gradient(135deg,${headerBg},#0e7490)`, padding: "18px 20px 14px", borderBottom: `3px solid ${accent}` }}>
// // //         <div style={{ fontSize: 9, color: `${accent}cc`, fontFamily: "'Courier New',monospace", marginBottom: 5, letterSpacing: "0.04em" }}>{"// resume.json — v2025"}</div>
// // //         <h1 style={{ fontSize: 19, fontWeight: 700, color: "#fff", fontFamily: "'Courier New',monospace", letterSpacing: "0.02em", marginBottom: 3 }}>{SAMPLE.name}</h1>
// // //         <div style={{ fontSize: 9.5, color: "rgba(180,230,240,0.85)", fontFamily: "'Courier New',monospace", marginBottom: 8 }}>{SAMPLE.title}</div>
// // //         <div style={{ display: "flex", flexWrap: "wrap", gap: 12, fontSize: 8.5, color: "rgba(180,230,240,0.7)", fontFamily: "'Courier New',monospace" }}>
// // //           {contacts.map(c => <span key={c}>{c}</span>)}
// // //         </div>
// // //       </div>
// // //       <div style={{ padding: "14px 20px" }}>
// // //         <ResumeBody accent={accent} sectionStyle="mono" fontFamily="Arial,Helvetica,sans-serif" />
// // //       </div>
// // //     </div>
// // //   );

// // //   if (id === "elegant") return (
// // //     <div style={{ fontFamily: "Georgia,'Times New Roman',serif", background: "#fff" }}>
// // //       <div style={{ display: "flex" }}>
// // //         {/* Left accent strip */}
// // //         <div style={{ width: 6, background: `linear-gradient(180deg,${a},${h})`, flexShrink: 0 }} />
// // //         {/* Header */}
// // //         <div style={{ flex: 1, padding: "20px 20px 16px", borderBottom: `1px solid #e7e5e4` }}>
// // //           <h1 style={{ fontSize: 24, fontWeight: 700, color: h, letterSpacing: "0.01em", marginBottom: 4, fontFamily: "Georgia,serif" }}>{SAMPLE.name}</h1>
// // //           <div style={{ fontSize: 11, color: a, fontWeight: 600, letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: 10 }}>{SAMPLE.title}</div>
// // //           <div style={{ display: "flex", flexWrap: "wrap", gap: 14, fontSize: 9.5, color: "#78716c" }}>
// // //             {contacts.map(c => <span key={c}>{c}</span>)}
// // //           </div>
// // //         </div>
// // //       </div>
// // //       <div style={{ padding: "16px 20px 16px 26px" }}>
// // //         <ResumeBody accent={a} sectionStyle="underline" fontFamily="Georgia,'Times New Roman',serif" />
// // //       </div>
// // //     </div>
// // //   );

// // //   if (id === "bold") return (
// // //     <div style={{ fontFamily: "Arial,Helvetica,sans-serif", background: "#fff" }}>
// // //       {/* Bold full-width header */}
// // //       <div style={{ background: h, padding: "22px 24px 18px" }}>
// // //         <h1 style={{ fontSize: 30, fontWeight: 900, color: "#fff", letterSpacing: "-0.03em", marginBottom: 2, lineHeight: 1 }}>{SAMPLE.name}</h1>
// // //         <div style={{ width: 48, height: 3, background: a, borderRadius: 2, margin: "8px 0 10px" }} />
// // //         <div style={{ fontSize: 11, color: "rgba(255,255,255,0.75)", textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 10 }}>{SAMPLE.title}</div>
// // //         <div style={{ display: "flex", flexWrap: "wrap", gap: 14, fontSize: 9.5, color: "rgba(255,255,255,0.6)" }}>
// // //           {contacts.map(c => <span key={c}>{c}</span>)}
// // //         </div>
// // //       </div>
// // //       {/* Bold section dividers */}
// // //       <div style={{ padding: "16px 24px" }}>
// // //         <ResumeBody accent={a} sectionStyle="filled" fontFamily="Arial,Helvetica,sans-serif" />
// // //       </div>
// // //     </div>
// // //   );

// // //   if (id === "sidebarlight") return (
// // //     <div style={{ display: "flex", fontFamily: "Arial,Helvetica,sans-serif", background: "#fff" }}>
// // //       {/* Light sidebar */}
// // //       <div style={{ width: 160, background: h, padding: "20px 14px", flexShrink: 0, borderRight: `3px solid ${a}` }}>
// // //         <div style={{ width: 48, height: 48, borderRadius: "50%", background: `${a}22`, border: `2px solid ${a}`, marginBottom: 12, display: "flex", alignItems: "center", justifyContent: "center" }}>
// // //           <div style={{ fontSize: 18, color: a, fontWeight: 700 }}>{SAMPLE.name[0]}</div>
// // //         </div>
// // //         <div style={{ fontSize: 10.5, fontWeight: 800, color: "#0f172a", marginBottom: 2 }}>{SAMPLE.name}</div>
// // //         <div style={{ fontSize: 9, color: a, fontWeight: 600, marginBottom: 12 }}>{SAMPLE.title}</div>
// // //         <div style={{ height: 1, background: `${a}30`, marginBottom: 10 }} />
// // //         <div style={{ fontSize: 8, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 6 }}>Contact</div>
// // //         {contacts.map(c => <div key={c} style={{ fontSize: 8.5, color: "#475569", marginBottom: 4, wordBreak: "break-all", lineHeight: 1.4 }}>{c}</div>)}
// // //         <div style={{ height: 1, background: `${a}30`, margin: "10px 0" }} />
// // //         <div style={{ fontSize: 8, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 6 }}>Skills</div>
// // //         {SAMPLE.skills.slice(0, 5).map(s => (
// // //           <div key={s} style={{ fontSize: 8.5, background: `${a}15`, color: a, padding: "2px 6px", borderRadius: 3, marginBottom: 4, fontWeight: 500 }}>{s}</div>
// // //         ))}
// // //       </div>
// // //       <div style={{ flex: 1, padding: "20px 18px" }}>
// // //         <ResumeBody accent={a} sectionStyle="underline" fontFamily="Arial,Helvetica,sans-serif" />
// // //       </div>
// // //     </div>
// // //   );

// // //   if (id === "academic") return (
// // //     <div style={{ fontFamily: "Georgia,'Times New Roman',serif", background: "#fff" }}>
// // //       {/* Academic dark header */}
// // //       <div style={{ background: h, padding: "20px 24px 16px" }}>
// // //         <h1 style={{ fontSize: 22, fontWeight: 700, color: "#fff", fontFamily: "Georgia,serif", marginBottom: 3, textAlign: "center" }}>{SAMPLE.name}</h1>
// // //         <div style={{ textAlign: "center", fontSize: 10, color: `${a}cc`, fontStyle: "italic", marginBottom: 10 }}>{SAMPLE.title}</div>
// // //         <div style={{ height: 1, background: `${a}60`, marginBottom: 8 }} />
// // //         <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: 14, fontSize: 9, color: "rgba(255,255,255,0.55)" }}>
// // //           {contacts.map(c => <span key={c}>{c}</span>)}
// // //         </div>
// // //       </div>
// // //       {/* Double rule divider */}
// // //       <div style={{ height: 3, background: a }} />
// // //       <div style={{ height: 1, background: `${a}40` }} />
// // //       <div style={{ padding: "16px 24px" }}>
// // //         <ResumeBody accent={a} sectionStyle="underline" fontFamily="Georgia,'Times New Roman',serif" />
// // //       </div>
// // //     </div>
// // //   );

// // //   return null;
// // // }

// // // // ── Main export ──
// // // // SCALE controls how large the preview is:
// // // //   0.28 → ~168px wide (template selector cards)
// // // //   0.40 → ~240px wide (larger previews if needed)
// // // export default function TemplateMini({ t, scale = 0.28, width = 600 }) {
// // //   const displayW = Math.round(width * scale);
// // //   const displayH = Math.round(900 * scale); // approximate A4 ratio

// // //   return (
// // //     <div style={{
// // //       width:    displayW,
// // //       height:   displayH,
// // //       overflow: "hidden",
// // //       position: "relative",
// // //       borderRadius: 3,
// // //     }}>
// // //       <div style={{
// // //         width,
// // //         transformOrigin: "top left",
// // //         transform:       `scale(${scale})`,
// // //         position:        "absolute",
// // //         top:  0,
// // //         left: 0,
// // //         background: "#fff",
// // //         minHeight: 900,
// // //       }}>
// // //         {renderResume(t.id, t.accent, t.headerBg)}
// // //       </div>
// // //     </div>
// // //   );
// // // }

// // // src/components/TemplateMini.jsx
// // // Renders a full-fidelity resume preview scaled down via CSS transform.
// // // This guarantees the preview EXACTLY matches the generated resume.
// // //
// // // How it works:
// // //   - Renders a full-size (600px wide) resume layout
// // //   - CSS transform: scale(0.28) shrinks it to ~168px wide
// // //   - The outer wrapper clips to the correct display size
// // //
// // // To add a new template:
// // //   1. Add a case in renderResume() below
// // //   2. Set active:true in servicesConfig.resumeTemplates

// // import React from "react";

// // // ── Sample data shown in every preview ──
// // const SAMPLE = {
// //   name:     "Jonathan Carter",
// //   title:    "Senior Product Manager",
// //   email:    "john@email.com",
// //   phone:    "(555) 123-4567",
// //   location: "New York, NY",
// //   linkedin: "linkedin.com/in/jcarter",
// //   summary:  "Results-driven Product Manager with 8+ years delivering high-impact products at Fortune 500 companies. Proven track record of increasing retention and driving revenue growth.",
// //   experience: [
// //     {
// //       title: "Senior Product Manager",
// //       company: "Google",
// //       location: "New York, NY",
// //       dates: "Jan 2020 – Present",
// //       bullets: [
// //         "Led cross-functional team of 12 to deliver 3 major features ahead of schedule",
// //         "Increased DAU by 34% through data-driven roadmap prioritization",
// //         "Managed $2M annual product budget across 4 verticals",
// //       ],
// //     },
// //     {
// //       title: "Product Manager",
// //       company: "Stripe",
// //       location: "San Francisco, CA",
// //       dates: "Mar 2017 – Dec 2019",
// //       bullets: [
// //         "Launched payments API now used by 5,000+ merchants globally",
// //         "Reduced customer churn by 18% via UX research and A/B testing",
// //       ],
// //     },
// //   ],
// //   education: { degree: "B.S. Computer Science", school: "MIT", year: "2015", gpa: "3.8" },
// //   skills: ["React", "Node.js", "Python", "SQL", "Agile", "Figma", "Data Analysis"],
// // };

// // // ── Shared section title styles ──
// // function SecTitle({ children, accent, style = "underline" }) {
// //   if (style === "filled") return (
// //     <div style={{ background: `${accent}18`, borderLeft: `3px solid ${accent}`, padding: "3px 8px", marginBottom: 8, borderRadius: "0 4px 4px 0" }}>
// //       <div style={{ fontSize: 9, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.1em", color: accent }}>{children}</div>
// //     </div>
// //   );
// //   if (style === "mono") return (
// //     <div style={{ background: `${accent}18`, borderLeft: `3px solid ${accent}`, padding: "3px 8px", marginBottom: 8, borderRadius: "0 4px 4px 0" }}>
// //       <div style={{ fontSize: 9, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.1em", color: accent, fontFamily: "'Courier New',monospace" }}>{`// ${children.toUpperCase()}`}</div>
// //     </div>
// //   );
// //   return (
// //     <div style={{ borderBottom: `1.5px solid ${accent}`, paddingBottom: 3, marginBottom: 8 }}>
// //       <div style={{ fontSize: 9, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.1em", color: accent }}>{children}</div>
// //     </div>
// //   );
// // }

// // // ── Shared body content (summary + experience + education + skills) ──
// // function ResumeBody({ accent, sectionStyle = "underline", fontFamily = "Arial,Helvetica,sans-serif" }) {
// //   return (
// //     <div style={{ fontFamily }}>
// //       {/* Summary */}
// //       <div style={{ marginBottom: 12 }}>
// //         <SecTitle accent={accent} style={sectionStyle}>Professional Summary</SecTitle>
// //         <p style={{ fontSize: 10, lineHeight: 1.6, color: "#374151", margin: 0 }}>{SAMPLE.summary}</p>
// //       </div>
// //       {/* Experience */}
// //       <div style={{ marginBottom: 12 }}>
// //         <SecTitle accent={accent} style={sectionStyle}>Work Experience</SecTitle>
// //         {SAMPLE.experience.map((exp, i) => (
// //           <div key={i} style={{ marginBottom: 10 }}>
// //             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 2 }}>
// //               <div>
// //                 <span style={{ fontWeight: 700, fontSize: 11, color: "#0f172a" }}>{exp.title}</span>
// //                 <span style={{ color: "#475569", fontSize: 10 }}> — {exp.company}</span>
// //               </div>
// //               <span style={{ fontSize: 9, color: "#64748b", fontStyle: "italic", whiteSpace: "nowrap" }}>{exp.dates}</span>
// //             </div>
// //             <ul style={{ margin: "3px 0 0 14px", padding: 0 }}>
// //               {exp.bullets.map((b, j) => (
// //                 <li key={j} style={{ fontSize: 9.5, color: "#374151", marginBottom: 2, lineHeight: 1.5 }}>{b}</li>
// //               ))}
// //             </ul>
// //           </div>
// //         ))}
// //       </div>
// //       {/* Education */}
// //       <div style={{ marginBottom: 12 }}>
// //         <SecTitle accent={accent} style={sectionStyle}>Education</SecTitle>
// //         <div style={{ display: "flex", justifyContent: "space-between" }}>
// //           <div>
// //             <span style={{ fontWeight: 700, fontSize: 11, color: "#0f172a" }}>{SAMPLE.education.degree}</span>
// //             <span style={{ color: "#475569", fontSize: 10 }}> — {SAMPLE.education.school}</span>
// //           </div>
// //           <span style={{ fontSize: 9, color: "#64748b", fontStyle: "italic" }}>{SAMPLE.education.year}</span>
// //         </div>
// //       </div>
// //       {/* Skills */}
// //       <div>
// //         <SecTitle accent={accent} style={sectionStyle}>Skills</SecTitle>
// //         <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
// //           {SAMPLE.skills.map(s => (
// //             <span key={s} style={{ fontSize: 9, background: `${accent}14`, color: accent, padding: "2px 7px", borderRadius: 3, border: `0.5px solid ${accent}30`, fontWeight: 600 }}>{s}</span>
// //           ))}
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }

// // // ── Per-template full-size renderers ──
// // function renderResume(id, accent, headerBg) {
// //   const a = accent;    // shorthand used throughout
// //   const h = headerBg; // shorthand used throughout
// //   const contacts = [SAMPLE.email, SAMPLE.phone, SAMPLE.location, SAMPLE.linkedin];

// //   if (id === "classic") return (
// //     <div style={{ fontFamily: "Georgia,'Times New Roman',serif", background: "#fff" }}>
// //       <div style={{ textAlign: "center", paddingBottom: 14, marginBottom: 14, borderBottom: `2px solid ${accent}` }}>
// //         <h1 style={{ fontSize: 22, fontWeight: 700, color: "#0f172a", marginBottom: 4, letterSpacing: "-0.01em" }}>{SAMPLE.name}</h1>
// //         <div style={{ fontSize: 10, color: "#555", marginBottom: 6 }}>{SAMPLE.title}</div>
// //         <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: 12, fontSize: 9.5, color: "#475569" }}>
// //           {contacts.map(c => <span key={c}>{c}</span>)}
// //         </div>
// //       </div>
// //       <ResumeBody accent={accent} sectionStyle="underline" fontFamily="Arial,Helvetica,sans-serif" />
// //     </div>
// //   );

// //   if (id === "modern") return (
// //     <div style={{ display: "flex", background: "#fff", fontFamily: "Arial,Helvetica,sans-serif" }}>
// //       <div style={{ width: 170, background: headerBg, padding: "20px 14px", flexShrink: 0 }}>
// //         <div style={{ width: 52, height: 52, borderRadius: "50%", background: "rgba(255,255,255,0.18)", marginBottom: 12 }} />
// //         <div style={{ fontSize: 13, fontWeight: 800, color: "#fff", marginBottom: 2 }}>{SAMPLE.name}</div>
// //         <div style={{ fontSize: 9.5, color: `${accent}dd`, background: "rgba(255,255,255,0.1)", padding: "2px 6px", borderRadius: 3, display: "inline-block", marginBottom: 12 }}>{SAMPLE.title}</div>
// //         <div style={{ height: 1, background: "rgba(255,255,255,0.15)", marginBottom: 12 }} />
// //         <div style={{ fontSize: 8, fontWeight: 700, color: "rgba(255,255,255,0.5)", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 6 }}>Contact</div>
// //         {contacts.map(c => <div key={c} style={{ fontSize: 8.5, color: "rgba(255,255,255,0.75)", marginBottom: 4, wordBreak: "break-all" }}>{c}</div>)}
// //         <div style={{ height: 1, background: "rgba(255,255,255,0.15)", margin: "12px 0" }} />
// //         <div style={{ fontSize: 8, fontWeight: 700, color: "rgba(255,255,255,0.5)", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 6 }}>Skills</div>
// //         {SAMPLE.skills.slice(0, 5).map((s, i) => (
// //           <div key={s} style={{ marginBottom: 5 }}>
// //             <div style={{ fontSize: 8.5, color: "rgba(255,255,255,0.8)", marginBottom: 2 }}>{s}</div>
// //             <div style={{ height: 3, background: "rgba(255,255,255,0.15)", borderRadius: 2 }}>
// //               <div style={{ height: "100%", width: `${85 - i * 8}%`, background: "rgba(255,255,255,0.65)", borderRadius: 2 }} />
// //             </div>
// //           </div>
// //         ))}
// //       </div>
// //       <div style={{ flex: 1, padding: "20px 18px" }}>
// //         <ResumeBody accent={accent} sectionStyle="filled" fontFamily="Arial,Helvetica,sans-serif" />
// //       </div>
// //     </div>
// //   );

// //   if (id === "executive") return (
// //     <div style={{ fontFamily: "Arial,Helvetica,sans-serif", background: "#fff" }}>
// //       <div style={{ background: headerBg, padding: "20px 24px 16px" }}>
// //         <h1 style={{ fontSize: 22, fontWeight: 700, color: "#fff", textTransform: "uppercase", letterSpacing: "0.06em", fontFamily: "Georgia,serif", marginBottom: 6 }}>{SAMPLE.name}</h1>
// //         <div style={{ height: 1.5, background: "rgba(255,255,255,0.3)", marginBottom: 2 }} />
// //         <div style={{ height: 0.5, background: "rgba(255,255,255,0.12)", marginBottom: 10 }} />
// //         <div style={{ display: "flex", flexWrap: "wrap", gap: 16, fontSize: 9.5, color: "rgba(255,255,255,0.6)" }}>
// //           {contacts.map(c => <span key={c}>{c}</span>)}
// //         </div>
// //       </div>
// //       <div style={{ padding: "16px 24px" }}>
// //         <ResumeBody accent={accent} sectionStyle="underline" fontFamily="Arial,Helvetica,sans-serif" />
// //       </div>
// //     </div>
// //   );

// //   if (id === "minimal") return (
// //     <div style={{ fontFamily: "'Helvetica Neue',Helvetica,Arial,sans-serif", background: "#fff" }}>
// //       <div style={{ paddingBottom: 14, marginBottom: 14, borderBottom: `2.5px solid ${accent}` }}>
// //         <h1 style={{ fontSize: 24, fontWeight: 300, color: "#0f172a", letterSpacing: "-0.02em", marginBottom: 4 }}>{SAMPLE.name}</h1>
// //         <div style={{ width: 28, height: 2.5, background: accent, borderRadius: 2, marginBottom: 8 }} />
// //         <div style={{ fontSize: 10, color: "#555", marginBottom: 6 }}>{SAMPLE.title}</div>
// //         <div style={{ display: "flex", flexWrap: "wrap", gap: 12, fontSize: 9.5, color: "#64748b" }}>
// //           {contacts.slice(0, 3).map(c => <span key={c}>{c}</span>)}
// //         </div>
// //       </div>
// //       <ResumeBody accent={accent} sectionStyle="underline" fontFamily="'Helvetica Neue',Helvetica,Arial,sans-serif" />
// //     </div>
// //   );

// //   if (id === "corporate") return (
// //     <div style={{ fontFamily: "Arial,Helvetica,sans-serif", background: "#fff" }}>
// //       <div style={{ background: `linear-gradient(135deg,${headerBg},${accent})`, padding: "20px 24px 16px" }}>
// //         <h1 style={{ fontSize: 20, fontWeight: 700, color: "#fff", fontFamily: "Georgia,serif", marginBottom: 3 }}>{SAMPLE.name}</h1>
// //         <div style={{ fontSize: 10, color: "rgba(200,225,255,0.8)", fontStyle: "italic", marginBottom: 10 }}>{SAMPLE.title}</div>
// //         <div style={{ height: 1, background: "rgba(255,255,255,0.2)", marginBottom: 8 }} />
// //         <div style={{ display: "flex", flexWrap: "wrap", gap: 14, fontSize: 9, color: "rgba(200,225,255,0.85)" }}>
// //           {contacts.map(c => <span key={c}>{c}</span>)}
// //         </div>
// //       </div>
// //       <div style={{ padding: "16px 24px" }}>
// //         <ResumeBody accent={accent} sectionStyle="filled" fontFamily="Arial,Helvetica,sans-serif" />
// //       </div>
// //     </div>
// //   );

// //   if (id === "creative") return (
// //     <div style={{ fontFamily: "Arial,Helvetica,sans-serif", background: "#fff" }}>
// //       <div style={{ background: `linear-gradient(135deg,${headerBg},${accent})`, padding: "22px 24px 38px", clipPath: "polygon(0 0,100% 0,100% 80%,0 100%)", marginBottom: -6 }}>
// //         <h1 style={{ fontSize: 24, fontWeight: 800, color: "#fff", fontFamily: "Georgia,serif", letterSpacing: "-0.02em", marginBottom: 4 }}>{SAMPLE.name}</h1>
// //         <div style={{ fontSize: 9.5, color: "rgba(255,210,220,0.9)", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 8 }}>{SAMPLE.title}</div>
// //         <div style={{ display: "flex", flexWrap: "wrap", gap: 12, fontSize: 9, color: "rgba(255,210,220,0.8)" }}>
// //           {contacts.slice(0, 3).map(c => <span key={c}>{c}</span>)}
// //         </div>
// //       </div>
// //       <div style={{ padding: "10px 24px 16px" }}>
// //         <ResumeBody accent={accent} sectionStyle="underline" fontFamily="Arial,Helvetica,sans-serif" />
// //       </div>
// //     </div>
// //   );

// //   if (id === "technical") return (
// //     <div style={{ fontFamily: "Arial,Helvetica,sans-serif", background: "#fff" }}>
// //       <div style={{ background: `linear-gradient(135deg,${headerBg},#0e7490)`, padding: "18px 20px 14px", borderBottom: `3px solid ${accent}` }}>
// //         <div style={{ fontSize: 9, color: `${accent}cc`, fontFamily: "'Courier New',monospace", marginBottom: 5, letterSpacing: "0.04em" }}>{"// resume.json — v2025"}</div>
// //         <h1 style={{ fontSize: 19, fontWeight: 700, color: "#fff", fontFamily: "'Courier New',monospace", letterSpacing: "0.02em", marginBottom: 3 }}>{SAMPLE.name}</h1>
// //         <div style={{ fontSize: 9.5, color: "rgba(180,230,240,0.85)", fontFamily: "'Courier New',monospace", marginBottom: 8 }}>{SAMPLE.title}</div>
// //         <div style={{ display: "flex", flexWrap: "wrap", gap: 12, fontSize: 8.5, color: "rgba(180,230,240,0.7)", fontFamily: "'Courier New',monospace" }}>
// //           {contacts.map(c => <span key={c}>{c}</span>)}
// //         </div>
// //       </div>
// //       <div style={{ padding: "14px 20px" }}>
// //         <ResumeBody accent={accent} sectionStyle="mono" fontFamily="Arial,Helvetica,sans-serif" />
// //       </div>
// //     </div>
// //   );

// //   if (id === "elegant") return (
// //     <div style={{ fontFamily: "Georgia,'Times New Roman',serif", background: "#fff" }}>
// //       <div style={{ display: "flex" }}>
// //         {/* Left accent strip */}
// //         <div style={{ width: 6, background: `linear-gradient(180deg,${a},${h})`, flexShrink: 0 }} />
// //         {/* Header */}
// //         <div style={{ flex: 1, padding: "20px 20px 16px", borderBottom: `1px solid #e7e5e4` }}>
// //           <h1 style={{ fontSize: 24, fontWeight: 700, color: h, letterSpacing: "0.01em", marginBottom: 4, fontFamily: "Georgia,serif" }}>{SAMPLE.name}</h1>
// //           <div style={{ fontSize: 11, color: a, fontWeight: 600, letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: 10 }}>{SAMPLE.title}</div>
// //           <div style={{ display: "flex", flexWrap: "wrap", gap: 14, fontSize: 9.5, color: "#78716c" }}>
// //             {contacts.map(c => <span key={c}>{c}</span>)}
// //           </div>
// //         </div>
// //       </div>
// //       <div style={{ padding: "16px 20px 16px 26px" }}>
// //         <ResumeBody accent={a} sectionStyle="underline" fontFamily="Georgia,'Times New Roman',serif" />
// //       </div>
// //     </div>
// //   );

// //   if (id === "bold") return (
// //     <div style={{ fontFamily: "Arial,Helvetica,sans-serif", background: "#fff" }}>
// //       {/* Bold full-width header */}
// //       <div style={{ background: h, padding: "22px 24px 18px" }}>
// //         <h1 style={{ fontSize: 30, fontWeight: 900, color: "#fff", letterSpacing: "-0.03em", marginBottom: 2, lineHeight: 1 }}>{SAMPLE.name}</h1>
// //         <div style={{ width: 48, height: 3, background: a, borderRadius: 2, margin: "8px 0 10px" }} />
// //         <div style={{ fontSize: 11, color: "rgba(255,255,255,0.75)", textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 10 }}>{SAMPLE.title}</div>
// //         <div style={{ display: "flex", flexWrap: "wrap", gap: 14, fontSize: 9.5, color: "rgba(255,255,255,0.6)" }}>
// //           {contacts.map(c => <span key={c}>{c}</span>)}
// //         </div>
// //       </div>
// //       {/* Bold section dividers */}
// //       <div style={{ padding: "16px 24px" }}>
// //         <ResumeBody accent={a} sectionStyle="filled" fontFamily="Arial,Helvetica,sans-serif" />
// //       </div>
// //     </div>
// //   );

// //   if (id === "sidebarlight") return (
// //     <div style={{ display: "flex", fontFamily: "Arial,Helvetica,sans-serif", background: "#fff" }}>
// //       {/* Light sidebar */}
// //       <div style={{ width: 160, background: h, padding: "20px 14px", flexShrink: 0, borderRight: `3px solid ${a}` }}>
// //         <div style={{ width: 48, height: 48, borderRadius: "50%", background: `${a}22`, border: `2px solid ${a}`, marginBottom: 12, display: "flex", alignItems: "center", justifyContent: "center" }}>
// //           <div style={{ fontSize: 18, color: a, fontWeight: 700 }}>{SAMPLE.name[0]}</div>
// //         </div>
// //         <div style={{ fontSize: 10.5, fontWeight: 800, color: "#0f172a", marginBottom: 2 }}>{SAMPLE.name}</div>
// //         <div style={{ fontSize: 9, color: a, fontWeight: 600, marginBottom: 12 }}>{SAMPLE.title}</div>
// //         <div style={{ height: 1, background: `${a}30`, marginBottom: 10 }} />
// //         <div style={{ fontSize: 8, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 6 }}>Contact</div>
// //         {contacts.map(c => <div key={c} style={{ fontSize: 8.5, color: "#475569", marginBottom: 4, wordBreak: "break-all", lineHeight: 1.4 }}>{c}</div>)}
// //         <div style={{ height: 1, background: `${a}30`, margin: "10px 0" }} />
// //         <div style={{ fontSize: 8, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 6 }}>Skills</div>
// //         {SAMPLE.skills.slice(0, 5).map(s => (
// //           <div key={s} style={{ fontSize: 8.5, background: `${a}15`, color: a, padding: "2px 6px", borderRadius: 3, marginBottom: 4, fontWeight: 500 }}>{s}</div>
// //         ))}
// //       </div>
// //       <div style={{ flex: 1, padding: "20px 18px" }}>
// //         <ResumeBody accent={a} sectionStyle="underline" fontFamily="Arial,Helvetica,sans-serif" />
// //       </div>
// //     </div>
// //   );

// //   if (id === "academic") return (
// //     <div style={{ fontFamily: "Georgia,'Times New Roman',serif", background: "#fff" }}>
// //       {/* Academic dark header */}
// //       <div style={{ background: h, padding: "20px 24px 16px" }}>
// //         <h1 style={{ fontSize: 22, fontWeight: 700, color: "#fff", fontFamily: "Georgia,serif", marginBottom: 3, textAlign: "center" }}>{SAMPLE.name}</h1>
// //         <div style={{ textAlign: "center", fontSize: 10, color: `${a}cc`, fontStyle: "italic", marginBottom: 10 }}>{SAMPLE.title}</div>
// //         <div style={{ height: 1, background: `${a}60`, marginBottom: 8 }} />
// //         <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: 14, fontSize: 9, color: "rgba(255,255,255,0.55)" }}>
// //           {contacts.map(c => <span key={c}>{c}</span>)}
// //         </div>
// //       </div>
// //       {/* Double rule divider */}
// //       <div style={{ height: 3, background: a }} />
// //       <div style={{ height: 1, background: `${a}40` }} />
// //       <div style={{ padding: "16px 24px" }}>
// //         <ResumeBody accent={a} sectionStyle="underline" fontFamily="Georgia,'Times New Roman',serif" />
// //       </div>
// //     </div>
// //   );

// //   // ── PROFESSIONAL: two-column header, navy, clean lines ──
// //   if (id === "professional") return (
// //     <div style={{ fontFamily: "Arial,Helvetica,sans-serif", background: "#fff" }}>
// //       <div style={{ background: h, padding: "20px 24px 16px" }}>
// //         <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", flexWrap: "wrap", gap: 10 }}>
// //           <div>
// //             <h1 style={{ fontSize: 24, fontWeight: 700, color: "#fff", letterSpacing: "0.01em", marginBottom: 4 }}>{SAMPLE.name}</h1>
// //             <div style={{ fontSize: 11, color: `${a}bb`, letterSpacing: "0.08em", textTransform: "uppercase" }}>{SAMPLE.title}</div>
// //           </div>
// //           <div style={{ textAlign: "right" }}>
// //             {contacts.slice(0,2).map(c => <div key={c} style={{ fontSize: 9.5, color: "rgba(255,255,255,0.6)", marginBottom: 3 }}>{c}</div>)}
// //           </div>
// //         </div>
// //         <div style={{ height: 2, background: a, marginTop: 14, borderRadius: 1 }} />
// //       </div>
// //       <div style={{ padding: "16px 24px" }}>
// //         <ResumeBody accent={a} sectionStyle="underline" fontFamily="Arial,Helvetica,sans-serif" />
// //       </div>
// //     </div>
// //   );

// //   // ── COMPACT: tight spacing, fits more content ──
// //   if (id === "compact") return (
// //     <div style={{ fontFamily: "Arial,Helvetica,sans-serif", background: "#fff" }}>
// //       <div style={{ background: h, padding: "12px 20px", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 8 }}>
// //         <div>
// //           <h1 style={{ fontSize: 20, fontWeight: 700, color: "#fff", marginBottom: 2 }}>{SAMPLE.name}</h1>
// //           <div style={{ fontSize: 10, color: "rgba(255,255,255,0.6)" }}>{SAMPLE.title}</div>
// //         </div>
// //         <div style={{ display: "flex", flexDirection: "column", gap: 2, textAlign: "right" }}>
// //           {contacts.slice(0,3).map(c => <span key={c} style={{ fontSize: 8.5, color: "rgba(255,255,255,0.5)" }}>{c}</span>)}
// //         </div>
// //       </div>
// //       <div style={{ padding: "10px 20px" }}>
// //         <div style={{ marginBottom: 7 }}>
// //           {/* <SecTitle accent={a} style="underline">Summary</SecTitle> */}
// //           <SecTitle accent={a} style={{ style: "underline" }}>Summary</SecTitle>
// //           <p style={{ fontSize: 9, lineHeight: 1.5, color: "#374151", margin: 0 }}>{SAMPLE.summary.slice(0,130)}...</p>
// //         </div>
// //         <div style={{ marginBottom: 7 }}>
// //           {/* <SecTitle accent={a} style="underline">Experience</SecTitle> */}
// //           <SecTitle accent={a} style={{ style: "underline" }}>Experience</SecTitle>
// //           {SAMPLE.experience.map((exp, i) => (
// //             <div key={i} style={{ marginBottom: 5 }}>
// //               <div style={{ display: "flex", justifyContent: "space-between" }}>
// //                 <span style={{ fontWeight: 700, fontSize: 10, color: "#0f172a" }}>{exp.title} — {exp.company}</span>
// //                 <span style={{ fontSize: 8.5, color: "#64748b", fontStyle: "italic" }}>{exp.dates}</span>
// //               </div>
// //               <div style={{ display: "flex", gap: 4, marginTop: 2 }}>
// //                 <span style={{ color: a, fontSize: 7, marginTop: 2 }}>▪</span>
// //                 <span style={{ fontSize: 8.5, color: "#475569", lineHeight: 1.4 }}>{exp.bullets[0]}</span>
// //               </div>
// //             </div>
// //           ))}
// //         </div>
// //         {/* <SecTitle accent={a} style="underline">Skills</SecTitle> */}
// //         <SecTitle accent={a} style={{ style: "underline" }}>Skills</SecTitle>
// //         <div style={{ display: "flex", flexWrap: "wrap", gap: 3 }}>
// //           {SAMPLE.skills.map(s => <span key={s} style={{ fontSize: 8.5, background: `${a}10`, color: a, padding: "1px 6px", borderRadius: 3, fontWeight: 600 }}>{s}</span>)}
// //         </div>
// //       </div>
// //     </div>
// //   );

// //   // ── CLEAN SERIF: warm double-rule header, serif ──
// //   if (id === "cleanserif") return (
// //     <div style={{ fontFamily: "Georgia,'Times New Roman',serif", background: "#fff", padding: "16px 20px" }}>
// //       <div style={{ textAlign: "center", borderBottom: `3px double ${a}`, paddingBottom: 12, marginBottom: 14 }}>
// //         <h1 style={{ fontSize: 24, fontWeight: 700, color: "#1a0a0a", letterSpacing: "0.02em", marginBottom: 4, fontFamily: "Georgia,serif" }}>{SAMPLE.name}</h1>
// //         <div style={{ fontSize: 11, color: a, fontWeight: 600, letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: 8 }}>{SAMPLE.title}</div>
// //         <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: 14, fontSize: 9.5, color: "#6b7280" }}>
// //           {contacts.map(c => <span key={c}>{c}</span>)}
// //         </div>
// //       </div>
// //       <ResumeBody accent={a} sectionStyle="underline" fontFamily="Georgia,'Times New Roman',serif" />
// //     </div>
// //   );

// //   // ── GOVERNMENT: strict federal format, uppercase, position bar ──
// //   if (id === "government") return (
// //     <div style={{ fontFamily: "Arial,Helvetica,sans-serif", background: "#fff" }}>
// //       <div style={{ background: h, padding: "16px 24px 14px", borderBottom: `4px solid ${a}` }}>
// //         <h1 style={{ fontSize: 20, fontWeight: 700, color: "#fff", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 6 }}>{SAMPLE.name}</h1>
// //         <div style={{ display: "flex", flexWrap: "wrap", gap: 14, fontSize: 9.5, color: "rgba(255,255,255,0.6)" }}>
// //           {contacts.map(c => <span key={c}>{c}</span>)}
// //         </div>
// //       </div>
// //       <div style={{ background: `${a}12`, padding: "5px 24px", borderBottom: `1px solid ${a}30` }}>
// //         <span style={{ fontSize: 10, fontWeight: 700, color: a, textTransform: "uppercase", letterSpacing: "0.06em" }}>Position Applied: </span>
// //         <span style={{ fontSize: 10, color: "#374151" }}>{SAMPLE.title}</span>
// //       </div>
// //       <div style={{ padding: "14px 24px" }}>
// //         <ResumeBody accent={a} sectionStyle="filled" fontFamily="Arial,Helvetica,sans-serif" />
// //       </div>
// //     </div>
// //   );

// //   // ── CLASSIC BLACK & WHITE ──
// //   if (id === "classic_bw") return (
// //     <div style={{ fontFamily: "Arial,Helvetica,sans-serif", background: "#fff" }}>
// //       <div style={{ textAlign: "center", borderBottom: "2px solid #000", paddingBottom: 10, marginBottom: 12 }}>
// //         <h1 style={{ fontSize: 22, fontWeight: 700, color: "#000", letterSpacing: "0.02em", marginBottom: 3 }}>{SAMPLE.name}</h1>
// //         <div style={{ fontSize: 9.5, color: "#333", marginBottom: 6 }}>{SAMPLE.title}</div>
// //         <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: 12, fontSize: 9, color: "#555" }}>
// //           {contacts.map(c => <span key={c}>{c}</span>)}
// //         </div>
// //       </div>
// //       <ResumeBody accent="#000000" sectionStyle="underline" fontFamily="Arial,Helvetica,sans-serif" />
// //     </div>
// //   );

// //   // ── TRADITIONAL ──
// //   if (id === "traditional") return (
// //     <div style={{ fontFamily: "Georgia,'Times New Roman',serif", background: "#fff", padding: "14px 18px" }}>
// //       <div style={{ textAlign: "center", marginBottom: 12, paddingBottom: 10, borderBottom: "1.5px solid #1a1a1a" }}>
// //         <h1 style={{ fontSize: 20, fontWeight: 700, color: "#000", fontFamily: "Georgia,serif", letterSpacing: "0.01em", marginBottom: 4 }}>{SAMPLE.name}</h1>
// //         <div style={{ fontSize: 9.5, color: "#444", marginBottom: 6 }}>{SAMPLE.title}</div>
// //         <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: 10, fontSize: 9, color: "#555" }}>
// //           {contacts.map(c => <span key={c}>{c}</span>)}
// //         </div>
// //       </div>
// //       <ResumeBody accent="#1a1a1a" sectionStyle="underline" fontFamily="Georgia,'Times New Roman',serif" />
// //     </div>
// //   );

// //   return null;
// // }

// // // ── Main export ──
// // // SCALE controls how large the preview is:
// // //   0.28 → ~168px wide (template selector cards)
// // //   0.40 → ~240px wide (larger previews if needed)
// // export default function TemplateMini({ t, scale = 0.28, width = 600 }) {
// //   const displayW = Math.round(width * scale);
// //   const displayH = Math.round(900 * scale); // approximate A4 ratio

// //   return (
// //     <div style={{
// //       width:    displayW,
// //       height:   displayH,
// //       overflow: "hidden",
// //       position: "relative",
// //       borderRadius: 3,
// //     }}>
// //       <div style={{
// //         width,
// //         transformOrigin: "top left",
// //         transform:       `scale(${scale})`,
// //         position:        "absolute",
// //         top:  0,
// //         left: 0,
// //         background: "#fff",
// //         minHeight: 900,
// //       }}>
// //         {renderResume(t.id, t.accent, t.headerBg)}
// //       </div>
// //     </div>
// //   );
// // }

// //--Below is updated
// // src/components/TemplateMini.jsx
// // Renders a full-fidelity resume preview scaled down via CSS transform.
// // This guarantees the preview EXACTLY matches the generated resume.
// //
// // How it works:
// //   - Renders a full-size (600px wide) resume layout
// //   - CSS transform: scale(0.28) shrinks it to ~168px wide
// //   - The outer wrapper clips to the correct display size
// //
// // To add a new template:
// //   1. Add a case in renderResume() below
// //   2. Set active:true in servicesConfig.resumeTemplates

// import React from "react";

// // ── Sample data shown in every preview ──
// const SAMPLE = {
//   name:     "Jonathan Carter",
//   title:    "Senior Product Manager",
//   email:    "john@email.com",
//   phone:    "(555) 123-4567",
//   location: "New York, NY",
//   linkedin: "linkedin.com/in/jcarter",
//   summary:  "Results-driven Product Manager with 8+ years delivering high-impact products at Fortune 500 companies. Proven track record of increasing retention and driving revenue growth.",
//   experience: [
//     {
//       title: "Senior Product Manager",
//       company: "Google",
//       location: "New York, NY",
//       dates: "Jan 2020 – Present",
//       bullets: [
//         "Led cross-functional team of 12 to deliver 3 major features ahead of schedule",
//         "Increased DAU by 34% through data-driven roadmap prioritization",
//         "Managed $2M annual product budget across 4 verticals",
//       ],
//     },
//     {
//       title: "Product Manager",
//       company: "Stripe",
//       location: "San Francisco, CA",
//       dates: "Mar 2017 – Dec 2019",
//       bullets: [
//         "Launched payments API now used by 5,000+ merchants globally",
//         "Reduced customer churn by 18% via UX research and A/B testing",
//       ],
//     },
//   ],
//   education: { degree: "B.S. Computer Science", school: "MIT", year: "2015", gpa: "3.8" },
//   skills: ["React", "Node.js", "Python", "SQL", "Agile", "Figma", "Data Analysis"],
// };

// // ── Shared section title styles ──
// function SecTitle({ children, accent, style = "underline" }) {
//   if (style === "filled") return (
//     <div style={{ background: `${accent}18`, borderLeft: `3px solid ${accent}`, padding: "3px 8px", marginBottom: 8, borderRadius: "0 4px 4px 0" }}>
//       <div style={{ fontSize: 9, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.1em", color: accent }}>{children}</div>
//     </div>
//   );
//   if (style === "mono") return (
//     <div style={{ background: `${accent}18`, borderLeft: `3px solid ${accent}`, padding: "3px 8px", marginBottom: 8, borderRadius: "0 4px 4px 0" }}>
//       <div style={{ fontSize: 9, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.1em", color: accent, fontFamily: "'Courier New',monospace" }}>{`// ${children.toUpperCase()}`}</div>
//     </div>
//   );
//   return (
//     <div style={{ borderBottom: `1.5px solid ${accent}`, paddingBottom: 3, marginBottom: 8 }}>
//       <div style={{ fontSize: 9, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.1em", color: accent }}>{children}</div>
//     </div>
//   );
// }

// // ── Shared body content (summary + experience + education + skills) ──
// function ResumeBody({ accent, sectionStyle = "underline", fontFamily = "Arial,Helvetica,sans-serif" }) {
//   return (
//     <div style={{ fontFamily }}>
//       {/* Summary */}
//       <div style={{ marginBottom: 12 }}>
//         <SecTitle accent={accent} style={sectionStyle}>Professional Summary</SecTitle>
//         <p style={{ fontSize: 10, lineHeight: 1.6, color: "#374151", margin: 0 }}>{SAMPLE.summary}</p>
//       </div>
//       {/* Experience */}
//       <div style={{ marginBottom: 12 }}>
//         <SecTitle accent={accent} style={sectionStyle}>Work Experience</SecTitle>
//         {SAMPLE.experience.map((exp, i) => (
//           <div key={i} style={{ marginBottom: 10 }}>
//             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 2 }}>
//               <div>
//                 <span style={{ fontWeight: 700, fontSize: 11, color: "#0f172a" }}>{exp.title}</span>
//                 <span style={{ color: "#475569", fontSize: 10 }}> — {exp.company}</span>
//               </div>
//               <span style={{ fontSize: 9, color: "#64748b", fontStyle: "italic", whiteSpace: "nowrap" }}>{exp.dates}</span>
//             </div>
//             <ul style={{ margin: "3px 0 0 14px", padding: 0 }}>
//               {exp.bullets.map((b, j) => (
//                 <li key={j} style={{ fontSize: 9.5, color: "#374151", marginBottom: 2, lineHeight: 1.5 }}>{b}</li>
//               ))}
//             </ul>
//           </div>
//         ))}
//       </div>
//       {/* Education */}
//       <div style={{ marginBottom: 12 }}>
//         <SecTitle accent={accent} style={sectionStyle}>Education</SecTitle>
//         <div style={{ display: "flex", justifyContent: "space-between" }}>
//           <div>
//             <span style={{ fontWeight: 700, fontSize: 11, color: "#0f172a" }}>{SAMPLE.education.degree}</span>
//             <span style={{ color: "#475569", fontSize: 10 }}> — {SAMPLE.education.school}</span>
//           </div>
//           <span style={{ fontSize: 9, color: "#64748b", fontStyle: "italic" }}>{SAMPLE.education.year}</span>
//         </div>
//       </div>
//       {/* Skills */}
//       <div>
//         <SecTitle accent={accent} style={sectionStyle}>Skills</SecTitle>
//         <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
//           {SAMPLE.skills.map(s => (
//             <span key={s} style={{ fontSize: 9, background: `${accent}14`, color: accent, padding: "2px 7px", borderRadius: 3, border: `0.5px solid ${accent}30`, fontWeight: 600 }}>{s}</span>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }

// // ── Per-template full-size renderers ──
// function renderResume(id, accent, headerBg) {
//   const a = accent;    // shorthand used throughout
//   const h = headerBg; // shorthand used throughout
//   const contacts = [SAMPLE.email, SAMPLE.phone, SAMPLE.location, SAMPLE.linkedin];

//   if (id === "classic") return (
//     <div style={{ fontFamily: "Georgia,'Times New Roman',serif", background: "#fff" }}>
//       <div style={{ textAlign: "center", paddingBottom: 14, marginBottom: 14, borderBottom: `2px solid ${accent}` }}>
//         <h1 style={{ fontSize: 22, fontWeight: 700, color: "#0f172a", marginBottom: 4, letterSpacing: "-0.01em" }}>{SAMPLE.name}</h1>
//         <div style={{ fontSize: 10, color: "#555", marginBottom: 6 }}>{SAMPLE.title}</div>
//         <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: 12, fontSize: 9.5, color: "#475569" }}>
//           {contacts.map(c => <span key={c}>{c}</span>)}
//         </div>
//       </div>
//       <ResumeBody accent={accent} sectionStyle="underline" fontFamily="Arial,Helvetica,sans-serif" />
//     </div>
//   );

//   if (id === "modern") return (
//     <div style={{ display: "flex", background: "#fff", fontFamily: "Arial,Helvetica,sans-serif" }}>
//       <div style={{ width: 170, background: headerBg, padding: "20px 14px", flexShrink: 0 }}>
//         <div style={{ width: 52, height: 52, borderRadius: "50%", background: "rgba(255,255,255,0.18)", marginBottom: 12 }} />
//         <div style={{ fontSize: 13, fontWeight: 800, color: "#fff", marginBottom: 2 }}>{SAMPLE.name}</div>
//         <div style={{ fontSize: 9.5, color: `${accent}dd`, background: "rgba(255,255,255,0.1)", padding: "2px 6px", borderRadius: 3, display: "inline-block", marginBottom: 12 }}>{SAMPLE.title}</div>
//         <div style={{ height: 1, background: "rgba(255,255,255,0.15)", marginBottom: 12 }} />
//         <div style={{ fontSize: 8, fontWeight: 700, color: "rgba(255,255,255,0.5)", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 6 }}>Contact</div>
//         {contacts.map(c => <div key={c} style={{ fontSize: 8.5, color: "rgba(255,255,255,0.75)", marginBottom: 4, wordBreak: "break-all" }}>{c}</div>)}
//         <div style={{ height: 1, background: "rgba(255,255,255,0.15)", margin: "12px 0" }} />
//         <div style={{ fontSize: 8, fontWeight: 700, color: "rgba(255,255,255,0.5)", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 6 }}>Skills</div>
//         {SAMPLE.skills.slice(0, 5).map((s, i) => (
//           <div key={s} style={{ marginBottom: 5 }}>
//             <div style={{ fontSize: 8.5, color: "rgba(255,255,255,0.8)", marginBottom: 2 }}>{s}</div>
//             <div style={{ height: 3, background: "rgba(255,255,255,0.15)", borderRadius: 2 }}>
//               <div style={{ height: "100%", width: `${85 - i * 8}%`, background: "rgba(255,255,255,0.65)", borderRadius: 2 }} />
//             </div>
//           </div>
//         ))}
//       </div>
//       <div style={{ flex: 1, padding: "20px 18px" }}>
//         <ResumeBody accent={accent} sectionStyle="filled" fontFamily="Arial,Helvetica,sans-serif" />
//       </div>
//     </div>
//   );

//   if (id === "executive") return (
//     <div style={{ fontFamily: "Arial,Helvetica,sans-serif", background: "#fff" }}>
//       <div style={{ background: headerBg, padding: "20px 24px 16px" }}>
//         <h1 style={{ fontSize: 22, fontWeight: 700, color: "#fff", textTransform: "uppercase", letterSpacing: "0.06em", fontFamily: "Georgia,serif", marginBottom: 6 }}>{SAMPLE.name}</h1>
//         <div style={{ height: 1.5, background: "rgba(255,255,255,0.3)", marginBottom: 2 }} />
//         <div style={{ height: 0.5, background: "rgba(255,255,255,0.12)", marginBottom: 10 }} />
//         <div style={{ display: "flex", flexWrap: "wrap", gap: 16, fontSize: 9.5, color: "rgba(255,255,255,0.6)" }}>
//           {contacts.map(c => <span key={c}>{c}</span>)}
//         </div>
//       </div>
//       <div style={{ padding: "16px 24px" }}>
//         <ResumeBody accent={accent} sectionStyle="underline" fontFamily="Arial,Helvetica,sans-serif" />
//       </div>
//     </div>
//   );

//   if (id === "minimal") return (
//     <div style={{ fontFamily: "'Helvetica Neue',Helvetica,Arial,sans-serif", background: "#fff" }}>
//       <div style={{ paddingBottom: 14, marginBottom: 14, borderBottom: `2.5px solid ${accent}` }}>
//         <h1 style={{ fontSize: 24, fontWeight: 300, color: "#0f172a", letterSpacing: "-0.02em", marginBottom: 4 }}>{SAMPLE.name}</h1>
//         <div style={{ width: 28, height: 2.5, background: accent, borderRadius: 2, marginBottom: 8 }} />
//         <div style={{ fontSize: 10, color: "#555", marginBottom: 6 }}>{SAMPLE.title}</div>
//         <div style={{ display: "flex", flexWrap: "wrap", gap: 12, fontSize: 9.5, color: "#64748b" }}>
//           {contacts.slice(0, 3).map(c => <span key={c}>{c}</span>)}
//         </div>
//       </div>
//       <ResumeBody accent={accent} sectionStyle="underline" fontFamily="'Helvetica Neue',Helvetica,Arial,sans-serif" />
//     </div>
//   );

//   if (id === "corporate") return (
//     <div style={{ fontFamily: "Arial,Helvetica,sans-serif", background: "#fff" }}>
//       <div style={{ background: `linear-gradient(135deg,${headerBg},${accent})`, padding: "20px 24px 16px" }}>
//         <h1 style={{ fontSize: 20, fontWeight: 700, color: "#fff", fontFamily: "Georgia,serif", marginBottom: 3 }}>{SAMPLE.name}</h1>
//         <div style={{ fontSize: 10, color: "rgba(200,225,255,0.8)", fontStyle: "italic", marginBottom: 10 }}>{SAMPLE.title}</div>
//         <div style={{ height: 1, background: "rgba(255,255,255,0.2)", marginBottom: 8 }} />
//         <div style={{ display: "flex", flexWrap: "wrap", gap: 14, fontSize: 9, color: "rgba(200,225,255,0.85)" }}>
//           {contacts.map(c => <span key={c}>{c}</span>)}
//         </div>
//       </div>
//       <div style={{ padding: "16px 24px" }}>
//         <ResumeBody accent={accent} sectionStyle="filled" fontFamily="Arial,Helvetica,sans-serif" />
//       </div>
//     </div>
//   );

//   if (id === "creative") return (
//     <div style={{ fontFamily: "Arial,Helvetica,sans-serif", background: "#fff" }}>
//       <div style={{ background: `linear-gradient(135deg,${headerBg},${accent})`, padding: "22px 24px 38px", clipPath: "polygon(0 0,100% 0,100% 80%,0 100%)", marginBottom: -6 }}>
//         <h1 style={{ fontSize: 24, fontWeight: 800, color: "#fff", fontFamily: "Georgia,serif", letterSpacing: "-0.02em", marginBottom: 4 }}>{SAMPLE.name}</h1>
//         <div style={{ fontSize: 9.5, color: "rgba(255,210,220,0.9)", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 8 }}>{SAMPLE.title}</div>
//         <div style={{ display: "flex", flexWrap: "wrap", gap: 12, fontSize: 9, color: "rgba(255,210,220,0.8)" }}>
//           {contacts.slice(0, 3).map(c => <span key={c}>{c}</span>)}
//         </div>
//       </div>
//       <div style={{ padding: "10px 24px 16px" }}>
//         <ResumeBody accent={accent} sectionStyle="underline" fontFamily="Arial,Helvetica,sans-serif" />
//       </div>
//     </div>
//   );

//   if (id === "technical") return (
//     <div style={{ fontFamily: "Arial,Helvetica,sans-serif", background: "#fff" }}>
//       <div style={{ background: `linear-gradient(135deg,${headerBg},#0e7490)`, padding: "18px 20px 14px", borderBottom: `3px solid ${accent}` }}>
//         <div style={{ fontSize: 9, color: `${accent}cc`, fontFamily: "'Courier New',monospace", marginBottom: 5, letterSpacing: "0.04em" }}>{"// resume.json — v2025"}</div>
//         <h1 style={{ fontSize: 19, fontWeight: 700, color: "#fff", fontFamily: "'Courier New',monospace", letterSpacing: "0.02em", marginBottom: 3 }}>{SAMPLE.name}</h1>
//         <div style={{ fontSize: 9.5, color: "rgba(180,230,240,0.85)", fontFamily: "'Courier New',monospace", marginBottom: 8 }}>{SAMPLE.title}</div>
//         <div style={{ display: "flex", flexWrap: "wrap", gap: 12, fontSize: 8.5, color: "rgba(180,230,240,0.7)", fontFamily: "'Courier New',monospace" }}>
//           {contacts.map(c => <span key={c}>{c}</span>)}
//         </div>
//       </div>
//       <div style={{ padding: "14px 20px" }}>
//         <ResumeBody accent={accent} sectionStyle="mono" fontFamily="Arial,Helvetica,sans-serif" />
//       </div>
//     </div>
//   );

//   if (id === "elegant") return (
//     <div style={{ fontFamily: "Georgia,'Times New Roman',serif", background: "#fff" }}>
//       <div style={{ display: "flex" }}>
//         {/* Left accent strip */}
//         <div style={{ width: 6, background: `linear-gradient(180deg,${a},${h})`, flexShrink: 0 }} />
//         {/* Header */}
//         <div style={{ flex: 1, padding: "20px 20px 16px", borderBottom: `1px solid #e7e5e4` }}>
//           <h1 style={{ fontSize: 24, fontWeight: 700, color: h, letterSpacing: "0.01em", marginBottom: 4, fontFamily: "Georgia,serif" }}>{SAMPLE.name}</h1>
//           <div style={{ fontSize: 11, color: a, fontWeight: 600, letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: 10 }}>{SAMPLE.title}</div>
//           <div style={{ display: "flex", flexWrap: "wrap", gap: 14, fontSize: 9.5, color: "#78716c" }}>
//             {contacts.map(c => <span key={c}>{c}</span>)}
//           </div>
//         </div>
//       </div>
//       <div style={{ padding: "16px 20px 16px 26px" }}>
//         <ResumeBody accent={a} sectionStyle="underline" fontFamily="Georgia,'Times New Roman',serif" />
//       </div>
//     </div>
//   );

//   if (id === "bold") return (
//     <div style={{ fontFamily: "Arial,Helvetica,sans-serif", background: "#fff" }}>
//       {/* Bold full-width header */}
//       <div style={{ background: h, padding: "22px 24px 18px" }}>
//         <h1 style={{ fontSize: 30, fontWeight: 900, color: "#fff", letterSpacing: "-0.03em", marginBottom: 2, lineHeight: 1 }}>{SAMPLE.name}</h1>
//         <div style={{ width: 48, height: 3, background: a, borderRadius: 2, margin: "8px 0 10px" }} />
//         <div style={{ fontSize: 11, color: "rgba(255,255,255,0.75)", textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 10 }}>{SAMPLE.title}</div>
//         <div style={{ display: "flex", flexWrap: "wrap", gap: 14, fontSize: 9.5, color: "rgba(255,255,255,0.6)" }}>
//           {contacts.map(c => <span key={c}>{c}</span>)}
//         </div>
//       </div>
//       {/* Bold section dividers */}
//       <div style={{ padding: "16px 24px" }}>
//         <ResumeBody accent={a} sectionStyle="filled" fontFamily="Arial,Helvetica,sans-serif" />
//       </div>
//     </div>
//   );

//   if (id === "sidebarlight") return (
//     <div style={{ display: "flex", fontFamily: "Arial,Helvetica,sans-serif", background: "#fff" }}>
//       {/* Light sidebar */}
//       <div style={{ width: 160, background: h, padding: "20px 14px", flexShrink: 0, borderRight: `3px solid ${a}` }}>
//         <div style={{ width: 48, height: 48, borderRadius: "50%", background: `${a}22`, border: `2px solid ${a}`, marginBottom: 12, display: "flex", alignItems: "center", justifyContent: "center" }}>
//           <div style={{ fontSize: 18, color: a, fontWeight: 700 }}>{SAMPLE.name[0]}</div>
//         </div>
//         <div style={{ fontSize: 10.5, fontWeight: 800, color: "#0f172a", marginBottom: 2 }}>{SAMPLE.name}</div>
//         <div style={{ fontSize: 9, color: a, fontWeight: 600, marginBottom: 12 }}>{SAMPLE.title}</div>
//         <div style={{ height: 1, background: `${a}30`, marginBottom: 10 }} />
//         <div style={{ fontSize: 8, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 6 }}>Contact</div>
//         {contacts.map(c => <div key={c} style={{ fontSize: 8.5, color: "#475569", marginBottom: 4, wordBreak: "break-all", lineHeight: 1.4 }}>{c}</div>)}
//         <div style={{ height: 1, background: `${a}30`, margin: "10px 0" }} />
//         <div style={{ fontSize: 8, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 6 }}>Skills</div>
//         {SAMPLE.skills.slice(0, 5).map(s => (
//           <div key={s} style={{ fontSize: 8.5, background: `${a}15`, color: a, padding: "2px 6px", borderRadius: 3, marginBottom: 4, fontWeight: 500 }}>{s}</div>
//         ))}
//       </div>
//       <div style={{ flex: 1, padding: "20px 18px" }}>
//         <ResumeBody accent={a} sectionStyle="filled" fontFamily="Arial,Helvetica,sans-serif" />
//       </div>
//     </div>
//   );

//   if (id === "academic") return (
//     <div style={{ fontFamily: "Georgia,'Times New Roman',serif", background: "#fff" }}>
//       {/* Academic dark header */}
//       <div style={{ background: h, padding: "20px 24px 16px" }}>
//         <h1 style={{ fontSize: 22, fontWeight: 700, color: "#fff", fontFamily: "Georgia,serif", marginBottom: 3, textAlign: "center" }}>{SAMPLE.name}</h1>
//         <div style={{ textAlign: "center", fontSize: 10, color: `${a}cc`, fontStyle: "italic", marginBottom: 10 }}>{SAMPLE.title}</div>
//         <div style={{ height: 1, background: `${a}60`, marginBottom: 8 }} />
//         <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: 14, fontSize: 9, color: "rgba(255,255,255,0.55)" }}>
//           {contacts.map(c => <span key={c}>{c}</span>)}
//         </div>
//       </div>
//       {/* Double rule divider */}
//       <div style={{ height: 3, background: a }} />
//       <div style={{ height: 1, background: `${a}40` }} />
//       <div style={{ padding: "16px 24px" }}>
//         <ResumeBody accent={a} sectionStyle="filled" fontFamily="Georgia,'Times New Roman',serif" />
//       </div>
//     </div>
//   );

//   // ── PROFESSIONAL: two-column header, navy, clean lines ──
//   if (id === "professional") return (
//     <div style={{ fontFamily: "Arial,Helvetica,sans-serif", background: "#fff" }}>
//       <div style={{ background: h, padding: "20px 24px 16px" }}>
//         <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", flexWrap: "wrap", gap: 10 }}>
//           <div>
//             <h1 style={{ fontSize: 24, fontWeight: 700, color: "#fff", letterSpacing: "0.01em", marginBottom: 4 }}>{SAMPLE.name}</h1>
//             <div style={{ fontSize: 11, color: `${a}bb`, letterSpacing: "0.08em", textTransform: "uppercase" }}>{SAMPLE.title}</div>
//           </div>
//           <div style={{ textAlign: "right" }}>
//             {contacts.slice(0,2).map(c => <div key={c} style={{ fontSize: 9.5, color: "rgba(255,255,255,0.6)", marginBottom: 3 }}>{c}</div>)}
//           </div>
//         </div>
//         <div style={{ height: 2, background: a, marginTop: 14, borderRadius: 1 }} />
//       </div>
//       <div style={{ padding: "16px 24px" }}>
//         <ResumeBody accent={a} sectionStyle="filled" fontFamily="Arial,Helvetica,sans-serif" />
//       </div>
//     </div>
//   );

//   // ── COMPACT: tight spacing, fits more content ──
//   if (id === "compact") return (
//     <div style={{ fontFamily: "Arial,Helvetica,sans-serif", background: "#fff" }}>
//       <div style={{ background: h, padding: "12px 20px", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 8 }}>
//         <div>
//           <h1 style={{ fontSize: 20, fontWeight: 700, color: "#fff", marginBottom: 2 }}>{SAMPLE.name}</h1>
//           <div style={{ fontSize: 10, color: "rgba(255,255,255,0.6)" }}>{SAMPLE.title}</div>
//         </div>
//         <div style={{ display: "flex", flexDirection: "column", gap: 2, textAlign: "right" }}>
//           {contacts.slice(0,3).map(c => <span key={c} style={{ fontSize: 8.5, color: "rgba(255,255,255,0.5)" }}>{c}</span>)}
//         </div>
//       </div>
//       <div style={{ padding: "10px 20px" }}>
//         <div style={{ marginBottom: 7 }}>
//           <SecTitle accent={a} variant="filled">Summary</SecTitle>
//           <p style={{ fontSize: 9, lineHeight: 1.5, color: "#374151", margin: 0 }}>{SAMPLE.summary.slice(0,130)}...</p>
//         </div>
//         <div style={{ marginBottom: 7 }}>
//           <SecTitle accent={a} variant="filled">Experience</SecTitle>
//           {SAMPLE.experience.map((exp, i) => (
//             <div key={i} style={{ marginBottom: 5 }}>
//               <div style={{ display: "flex", justifyContent: "space-between" }}>
//                 <span style={{ fontWeight: 700, fontSize: 10, color: "#0f172a" }}>{exp.title} — {exp.company}</span>
//                 <span style={{ fontSize: 8.5, color: "#64748b", fontStyle: "italic" }}>{exp.dates}</span>
//               </div>
//               <div style={{ display: "flex", gap: 4, marginTop: 2 }}>
//                 <span style={{ color: a, fontSize: 7, marginTop: 2 }}>▪</span>
//                 <span style={{ fontSize: 8.5, color: "#475569", lineHeight: 1.4 }}>{exp.bullets[0]}</span>
//               </div>
//             </div>
//           ))}
//         </div>
//         <SecTitle accent={a} variant="filled">Skills</SecTitle>
//         <div style={{ display: "flex", flexWrap: "wrap", gap: 3 }}>
//           {SAMPLE.skills.map(s => <span key={s} style={{ fontSize: 8.5, background: `${a}10`, color: a, padding: "1px 6px", borderRadius: 3, fontWeight: 600 }}>{s}</span>)}
//         </div>
//       </div>
//     </div>
//   );

//   // ── CLEAN SERIF: warm double-rule header, serif ──
//   if (id === "cleanserif") return (
//     <div style={{ fontFamily: "Georgia,'Times New Roman',serif", background: "#fff", padding: "16px 20px" }}>
//       <div style={{ textAlign: "center", borderBottom: `3px double ${a}`, paddingBottom: 12, marginBottom: 14 }}>
//         <h1 style={{ fontSize: 24, fontWeight: 700, color: "#1a0a0a", letterSpacing: "0.02em", marginBottom: 4, fontFamily: "Georgia,serif" }}>{SAMPLE.name}</h1>
//         <div style={{ fontSize: 11, color: a, fontWeight: 600, letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: 8 }}>{SAMPLE.title}</div>
//         <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: 14, fontSize: 9.5, color: "#6b7280" }}>
//           {contacts.map(c => <span key={c}>{c}</span>)}
//         </div>
//       </div>
//       <ResumeBody accent={a} sectionStyle="underline" fontFamily="Georgia,'Times New Roman',serif" />
//     </div>
//   );

//   // ── GOVERNMENT: strict federal format, uppercase, position bar ──
//   if (id === "government") return (
//     <div style={{ fontFamily: "Arial,Helvetica,sans-serif", background: "#fff" }}>
//       <div style={{ background: h, padding: "16px 24px 14px", borderBottom: `4px solid ${a}` }}>
//         <h1 style={{ fontSize: 20, fontWeight: 700, color: "#fff", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 6 }}>{SAMPLE.name}</h1>
//         <div style={{ display: "flex", flexWrap: "wrap", gap: 14, fontSize: 9.5, color: "rgba(255,255,255,0.6)" }}>
//           {contacts.map(c => <span key={c}>{c}</span>)}
//         </div>
//       </div>
//       <div style={{ background: `${a}12`, padding: "5px 24px", borderBottom: `1px solid ${a}30` }}>
//         <span style={{ fontSize: 10, fontWeight: 700, color: a, textTransform: "uppercase", letterSpacing: "0.06em" }}>Position Applied: </span>
//         <span style={{ fontSize: 10, color: "#374151" }}>{SAMPLE.title}</span>
//       </div>
//       <div style={{ padding: "14px 24px" }}>
//         <ResumeBody accent={a} sectionStyle="filled" fontFamily="Arial,Helvetica,sans-serif" />
//       </div>
//     </div>
//   );

//   return null;
// }

// // ── Main export ──
// // SCALE controls how large the preview is:
// //   0.28 → ~168px wide (template selector cards)
// //   0.40 → ~240px wide (larger previews if needed)
// export default function TemplateMini({ t, scale = 0.28, width = 600 }) {
//   const displayW = Math.round(width * scale);
//   const displayH = Math.round(900 * scale); // approximate A4 ratio

//   return (
//     <div style={{
//       width:    displayW,
//       height:   displayH,
//       overflow: "hidden",
//       position: "relative",
//       borderRadius: 3,
//     }}>
//       <div style={{
//         width,
//         transformOrigin: "top left",
//         transform:       `scale(${scale})`,
//         position:        "absolute",
//         top:  0,
//         left: 0,
//         background: "#fff",
//         minHeight: 900,
//       }}>
//         {renderResume(t.id, t.accent, t.headerBg)}
//       </div>
//     </div>
//   );
// }

//--new code
// src/components/TemplateMini.jsx
// Renders the exact same HTML as the downloaded resume, scaled down.
// Uses buildResumeHTML — single source of truth.
// Landing page, modal previews, and generator all show identical output.

import React, { useRef, useEffect, useState } from "react";
import { buildResumeHTML } from "../utils/generateResumeDoc";

// ── Sample resume data for previews ──
const SAMPLE_RESUME = {
  name:     "Jonathan Carter",
  title:    "Senior Software Engineer",
  email:    "j.carter@email.com",
  phone:    "(555) 123-4567",
  location: "San Francisco, CA",
  linkedin: "linkedin.com/in/jcarter",
  summary:  "Senior Software Engineer with 8+ years delivering scalable web applications at Fortune 500 companies. Proven track record of reducing system latency by 40% and leading cross-functional teams of 10+ engineers. Expert in cloud-native architecture, microservices, and full-stack development.",
  experience: [
    {
      title:     "Senior Software Engineer",
      company:   "Google",
      location:  "San Francisco, CA",
      startDate: "Jan 2020",
      endDate:   "Present",
      bullets: [
        "Architected microservices migration for 50+ APIs, reducing deployment time by 40%",
        "Led cross-functional team of 12 engineers to deliver 3 major product features on schedule",
        "Optimized database queries reducing average response time from 800ms to 120ms",
        "Implemented CI/CD pipeline improving release frequency from monthly to weekly",
      ],
    },
    {
      title:     "Software Engineer",
      company:   "Stripe",
      location:  "San Francisco, CA",
      startDate: "Mar 2017",
      endDate:   "Dec 2019",
      bullets: [
        "Built payments API now processing $2B+ in annual transactions for 5,000+ merchants",
        "Reduced customer churn by 18% through data-driven UX improvements and A/B testing",
        "Designed real-time fraud detection system reducing chargebacks by 25%",
      ],
    },
    {
      title:     "Junior Developer",
      company:   "Salesforce",
      location:  "Austin, TX",
      startDate: "Jun 2015",
      endDate:   "Feb 2017",
      bullets: [
        "Developed 15+ customer-facing features used by 500,000+ enterprise users",
        "Reduced bug backlog by 60% through systematic code review and testing protocols",
      ],
    },
  ],
  education: [
    {
      degree:   "B.S. Computer Science",
      school:   "MIT",
      location: "Cambridge, MA",
      year:     "2015",
      gpa:      "",
    },
  ],
  skills: {
    technical: ["React", "Node.js", "Python", "TypeScript", "AWS", "Kubernetes"],
    tools:     ["Docker", "Terraform", "Datadog", "GitHub Actions"],
    soft:      ["Team Leadership", "System Design", "Agile/Scrum"],
  },
  certifications: ["AWS Solutions Architect", "Google Cloud Professional"],
};

export default function TemplateMini({ t, scale = 0.28, width = 794 }) {
  const iframeRef = useRef(null);
  const [loaded, setLoaded]   = useState(false);

  // Build the exact same HTML used for downloads
  const html = buildResumeHTML(SAMPLE_RESUME, t.id, { showHint: false });

  const displayW = Math.round(width  * scale);
  const displayH = Math.round(1122   * scale); // A4 height in px at 96dpi

  useEffect(() => {
    setLoaded(false);
  }, [t.id]);

  return (
    <div style={{
      width:        displayW,
      height:       displayH,
      overflow:     "hidden",
      position:     "relative",
      borderRadius: 3,
      background:   "#fff",
    }}>
      {/* Scaled iframe — renders exact HTML */}
      <iframe
        ref={iframeRef}
        title={`${t.name} preview`}
        srcDoc={html}
        scrolling="no"
        onLoad={() => setLoaded(true)}
        style={{
          width:           `${width}px`,
          height:          `${Math.round(1122)}px`,
          border:          "none",
          transformOrigin: "top left",
          transform:       `scale(${scale})`,
          position:        "absolute",
          top:             0,
          left:            0,
          background:      "#fff",
          pointerEvents:   "none",
          opacity:         loaded ? 1 : 0,
          transition:      "opacity 0.3s ease",
        }}
      />
      {/* Loading skeleton */}
      {!loaded && (
        <div style={{
          position:   "absolute",
          inset:      0,
          background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
          backgroundSize: "200% 100%",
          animation:  "shimmer 1.5s infinite",
        }} />
      )}
      <style>{`
        @keyframes shimmer {
          0%   { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
      `}</style>
    </div>
  );
}
